import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnhancedPeopleProfileSnapshotComponent } from './enhanced-people-profile-snapshot.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { i18nPipeModule } from 'src/app/pipes/i18n-convertor-pipe/i18n-convertor.module';
import {ButtonModule, CardsModule} from '@xref/xref-lib';
import { OptInProfileDetailModalModule } from "../opt-in-profile-detail-modal/opt-in-profile-detail-modal.module";
import {
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';

@NgModule({
  declarations: [EnhancedPeopleProfileSnapshotComponent],
  imports: [
    CommonModule,
    ModalModule,
    i18nPipeModule,
    ButtonModule,
    OptInProfileDetailModalModule,
    XrefTooltipModule,
    CardsModule
  ],
  exports: [
    EnhancedPeopleProfileSnapshotComponent
  ]
})
export class EnhancedPeopleProfileSnapshotModule { }
